import QueryString from "qs"
import http from "../index"
import {
  apiApproveOrder,
  apiRejectOrder,
  apiExportExcel,
  apiReceiveOrder,
  apiPurchaseOrder,
  apiExportExcelReport,
} from "./urls"
const approveOrder = id => http.put(apiApproveOrder(id))
const rejectOrder = (id, body) => http.put(apiRejectOrder(id), body)
const exportData = params =>
  http.get(apiExportExcel, { responseType: "blob", params: params })
const exportReport = params =>
  http.get(apiExportExcelReport, { responseType: "blob", params: params })
const receiveOrder = id => http.put(apiReceiveOrder(id))
const purchaseOrder = id => http.put(apiPurchaseOrder(id))

const OrderService = {
  approveOrder,
  rejectOrder,
  exportData,
  receiveOrder,
  purchaseOrder,
  exportReport
}
export default OrderService
